"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCardStyle = exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _layout = require("./layout.js");

var _CPanel = require("./CPanel.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./type.js");

require("./PanelBG.js");

require("./PanelHeader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n    transition: box-shadow 0.35s ease;\n\n    &.isClickable {\n      cursor: pointer;\n\n      &:hover {\n        box-shadow: ", ";\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CCard = function CCard(props) {
  return _react.default.createElement(StyledCard, (0, _chunkB2edacfb.g)({}, props, {
    className: (0, _classnames.default)(props.className, (!!props.onClick || !!props.href || !!props.to) && "isClickable")
  }));
};

var withCardStyle = function withCardStyle(component) {
  return (0, _CPanel.withPanelStyle)((0, _styledComponents.default)(component).withConfig({
    displayName: "CCard",
    componentId: "sc-9jf7wo-0"
  })(_templateObject(), function (props) {
    return props.theme[props.hoverElevation || "$box-shadow-2"];
  }));
};

exports.withCardStyle = withCardStyle;
var StyledCard = withCardStyle(_layout.Box);
CCard.displayName = "CCard";
CCard.propTypes = (0, _chunkB2edacfb.i)({}, _layout.Box.propTypes, {
  onClick: _propTypes.default.func,
  hoverElevation: _propTypes.default.string
});
CCard.defaultProps = _layout.Box.defaultProps;
CCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CCard",
  "props": {
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "hoverElevation": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  },
  "composes": ["../../layout/layout"]
};
var _default = CCard;
exports.default = _default;
CCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CCard",
  "composes": ["./chunk-b2edacfb.js"]
};